import React, { Fragment, useEffect, useState, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';
import { Button, Card, CardBody, Table, Input, Row, Col, FormGroup } from 'reactstrap';
import LoaderButton from '../loader-button/LoaderButton';
import Switch from 'react-switch';
import BzCardHeader from '../bz/BzCardHeader';
import ButtonIcon from '../common/ButtonIcon';

// import { onError } from '../../libs/errorLib';
import Loader from '../common/Loader';
// import Loading from '../../components/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import BZAPIService from '../../services/BZAPIService';
import Heading from '../common/Heading';
import { toast } from 'react-toastify';

import { VendorsContext } from '../../context/VendorsContext';
import { DashboardContext } from '../../context/DashboardContext';
import BulkUpdateWizard from '../managed-product/BulkUpdateWizard';
import PlanProjectCell, { BugZeroPlanLabel, DeviceCountCell } from '../plan/inventory/PlanProjectCell';
import { usePlanProjectGate } from '../plan/inventory/usePlanProjectGate';
import { useDeviceCounts } from '../plan/inventory/useDeviceCounts';
import { productDisplayName } from '../bz/productDisplayName';

export default function ManagedProductListing() {
  const { vendorId } = useParams();
  const [managedProducts, setManagedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  // const [vendor, setVendor] = useState(null);
  const [isConfigured, setIsConfigured] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [showBulkUpdateWizard, setShowBulkUpdateWizard] = useState(false);

  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  // eslint-disable-next-line
  const [dashboard, setDashboard] = useContext(DashboardContext);
  const vendor = vendors?.filter(v => v.id === vendorId)[0];

  const canCreatePlanProject = usePlanProjectGate(vendorId);
  // one request for the whole list, cached for the session
  const deviceCounts = useDeviceCounts(managedProducts, canCreatePlanProject);

  // Helper functions for selection
  const isAnySelected = () => Object.values(selectedProducts).some(v => v === true);
  const getSelectedCount = () => Object.values(selectedProducts).filter(v => v === true).length;
  const getSelectedIds = () => Object.keys(selectedProducts).filter(id => selectedProducts[id] === true);

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        const managedProducts = await loadManagedProducts();
        setManagedProducts(managedProducts);
        const service = dashboard?.services?.filter(service => {
          return service.vendorId === vendorId ? service : null;
        });
        if (service && service.length > 0) {
          setIsConfigured(
            service[0].status === 'NOT CONFIGURED' ? false : service[0].status === 'OPERATIONAL' ? true : true
          );
        }
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
    }

    onLoad();
    // eslint-disable-next-line
  }, [vendorId]);

  async function updateProducts() {
    try {
      setIsUpdating(true);
      const managedProducts = await loadManagedProducts();
      console.log('managedProducts', managedProducts);
      setManagedProducts(managedProducts);
      setIsUpdating(false);
    } catch (e) {
      console.log(e);
      setIsUpdating(false);
    }
  }

  async function handleDelete(managedProduct) {
    const confirmed = window.confirm(`Are you sure you want to delete ${managedProduct.name}?`);

    if (!confirmed || !managedProduct) {
      return;
    }

    // setIsDeleting(true);

    try {
      await BZAPIService.deleteManagedProduct(managedProduct.id);
      const managedProducts = await loadManagedProducts();
      setManagedProducts(managedProducts);
    } catch (e) {
      console.log(e);
      toast.error('Failed to delete product');
    }
  }

  async function handleToggleEnable(managedProduct) {
    const confirmed = window.confirm(
      `Are you sure you want to ${managedProduct.isDisabled ? 'enable' : 'disable'} ${managedProduct.name}?`
    );

    if (!confirmed || !managedProduct) {
      return;
    }

    managedProduct.isDisabled = !managedProduct.isDisabled;

    try {
      await BZAPIService.createOrUpdateManagedProduct(managedProduct);
      const managedProducts = await loadManagedProducts();
      setManagedProducts(managedProducts);
    } catch (e) {
      console.log(e);
      toast.error('Failed to update product');
    }
  }
  function loadManagedProducts() {
    return BZAPIService.listManagedProducts(vendorId);
  }

  function handleSelectProduct(productId) {
    setSelectedProducts({
      ...selectedProducts,
      [productId]: !selectedProducts[productId]
    });
  }

  function handleSelectAll() {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    const newSelected = {};
    managedProducts.forEach(product => {
      newSelected[product.id] = newSelectAll;
    });
    setSelectedProducts(newSelected);
  }

  function handleBulkUpdate() {
    setShowBulkUpdateWizard(true);
  }

  function handleBulkUpdateSuccess() {
    setShowBulkUpdateWizard(false);
    setSelectedProducts({});
    setSelectAll(false);
    updateProducts();
  }

  function renderManagedProductsList(managedProducts) {
    return managedProducts.map(managedProduct => (
      <tr key={managedProduct.id}>
        <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '1em' }}>
          <FormGroup check className="mb-0 d-flex justify-content-center">
            <Input
              type="checkbox"
              checked={selectedProducts[managedProduct.id] || false}
              onChange={() => handleSelectProduct(managedProduct.id)}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer'
              }}
            />
          </FormGroup>
        </td>
        <td style={{ padding: 0 }}>
          <Link
            style={{
              display: 'inline-block',
              width: '100%',
              height: '100%',
              padding: '1em'
            }}
            key={managedProduct.id}
            to={`/vendors/${vendorId}/products/${managedProduct.id}/${managedProduct.name}`}
          >
            {productDisplayName(vendorId, managedProduct.name)}
          </Link>
        </td>
        <td>
          {managedProduct.lastExecution
            ? moment
                .utc(managedProduct.lastExecution)
                .local()
                .fromNow()
            : 'Pending...'}
        </td>
        <td>
          <Switch
            onChange={() => handleToggleEnable(managedProduct)}
            checked={!managedProduct.isDisabled}
            onColor="#253746"
          />
        </td>
        <td>
          <DeviceCountCell count={deviceCounts.get(managedProduct.id)} canCreatePlanProject={canCreatePlanProject} />
        </td>
        <td>
          <PlanProjectCell managedProduct={managedProduct} canCreatePlanProject={canCreatePlanProject} />
        </td>
        {vendorId === 'hpe' && (
          <td>
            <Button color="falcon-danger" size="sm" onClick={() => handleDelete(managedProduct)}>
              <FontAwesomeIcon icon={faTimes} className="font-size-sm" />
            </Button>{' '}
          </td>
        )}
      </tr>
    ));
  }
  // console.log('vendorId', vendorId);
  if (isLoading) return <Loader text="Loading products..." />;

  return (
    <Fragment>
      <Heading
        title={vendor?.name?.replace('Systems', 'Networks') || 'Vendor'}
        subtitle={`Managed products`}
        className="mb-4 mt-3"
        icon="list"
      />
      <Card>
        {vendorId === 'hpe' && (
          <BzCardHeader
            title={
              <LinkContainer key="new" to={`/vendors/${vendorId}/products/new`}>
                <ButtonIcon color="falcon-default" size="sm" icon="plus" iconClassName="fs--2">
                  Add managed product
                </ButtonIcon>
              </LinkContainer>
            }
          />
        )}
        <CardBody className="fs--1">
          <Row className="mb-3">
            <Col className="text-left">
              <Button color="primary" disabled={!isAnySelected()} onClick={handleBulkUpdate}>
                Bulk Update ({getSelectedCount()})
              </Button>
            </Col>
            <Col className="text-right">
              <LoaderButton
                className={`${isConfigured ? '' : 'd-none'} btn btn-falcon-danger`}
                onClick={updateProducts}
                name="save-and-add"
                isLoading={isUpdating}
                title="Update Products"
                aria-label="Update Products"
              >
                <FontAwesomeIcon icon="redo" />
              </LoaderButton>
            </Col>
          </Row>

          {managedProducts.length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th style={{ width: '60px', textAlign: 'center', padding: '1em' }}>
                    <FormGroup check className="mb-0 d-flex justify-content-center">
                      <Input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        style={{
                          width: '18px',
                          height: '18px',
                          cursor: 'pointer'
                        }}
                      />
                    </FormGroup>
                  </th>
                  <th>Name</th>
                  <th>Last Sync</th>
                  <th>Enabled</th>
                  <th>Devices</th>
                  <th>
                    <BugZeroPlanLabel />
                  </th>
                  {vendorId === 'hpe' && <th>Remove</th>}
                </tr>
              </thead>
              <tbody>{renderManagedProductsList(managedProducts)}</tbody>
            </Table>
          ) : (
            <div className="text-center">No managed products</div>
          )}
        </CardBody>
      </Card>

      {/* Bulk Update Wizard */}
      <BulkUpdateWizard
        isOpen={showBulkUpdateWizard}
        toggle={() => setShowBulkUpdateWizard(false)}
        selectedProductIds={getSelectedIds()}
        selectedProducts={managedProducts.filter(p => selectedProducts[p.id])}
        vendorId={vendorId}
        vendor={vendor}
        onSuccess={handleBulkUpdateSuccess}
      />
    </Fragment>
  );
}
